import clsx from "clsx"
import { FC, PropsWithChildren, useMemo } from "react"
import styles from "./ToastContent.module.scss"

interface IToastContent {}

export const ToastContent: FC<PropsWithChildren<IToastContent>> = ({
  children
}) => {
  const triangles = useMemo(() => {
    return {
      top: `${Math.floor(Math.random() * 80) + 10}%`,
      bottom: `${Math.floor(Math.random() * 80) + 10}%`
    }
  }, [])

  return (
    <>
      <div className={clsx(styles.ToastContent)}>{children}</div>
      <div className={clsx(styles.ToastContent_triangles)}>
        <div
          className={clsx(styles.ToastContent_triangle, styles.top)}
          style={{ left: triangles.top }}
        />
        <div
          className={clsx(styles.ToastContent_triangle, styles.bottom)}
          style={{ left: triangles.bottom }}
        />
      </div>
    </>
  )
}
